import React from 'react'
import MainHeading from '../../../../../components/MainHeading/MainHeading'
import TimeLineSteps from '../../../../../components/TimeLineSteps/TimeLineSteps'
import AfterHoursModal from './AfterHoursModal'
import { RenderContent } from './RenderContent'
import RenderFooter from './RenderFooter'
import ContentLayout from '../../../../../components/ContentLayout/ContentLayout'
import useScreen from '../../../../../hooks/useScreen'
import PropTypes from 'prop-types'

const RequestPageComponent = ({
    isEstimate,
    steps,
    setSteps,
    afterHoursModalOpen,
    setAfterHoursModalOpen,
    onCreateRequest,
    selectedAsset,
    setSelectedAsset,
    filteredOpenRequests,
    onFilterOpenRequests,
    onCheckAftersHours,
    formRef,
    error,
    setError,
    isValidForm,
    allowSubmitWithError,
    setIsValidForm,
    successfulSubmit,
    setSuccessfulSubmit,
    resetTouch,
    setResetTouch,
    images,
    photosIds,
    setImages,
    setPhotosIds,
    onNextStep,
    history,
    listOfRequests,
}) => {
    const { isMobile, isTablet } = useScreen()

    return (
        <ContentLayout>
            <MainHeading
                isBlack={isMobile || isTablet}
                title={
                    isEstimate
                        ? 'Create Service Estimate'
                        : 'Create Repair Request'
                }
                content={
                    <TimeLineSteps
                        steps={steps}
                        key="Stepper"
                        isStepper
                        isAbsolute={false}
                        isDark
                        showDescription={false}
                    />
                }
                hasGoBack
                steps={steps}
                setSteps={setSteps}
                listOfRequests={listOfRequests}
                setSelectedAsset={setSelectedAsset}
            />
            <AfterHoursModal
                onSubmit={onCreateRequest}
                isOpen={afterHoursModalOpen}
                setIsOpen={setAfterHoursModalOpen}
            />
            <div className="w-full flex-grow h-full max-h-full overflow-auto lg:px-6 lg:py-8">
                <RenderContent
                    steps={steps}
                    selectedAsset={selectedAsset}
                    setSelectedAsset={setSelectedAsset}
                    filteredOpenRequests={filteredOpenRequests}
                    onFilterOpenRequests={onFilterOpenRequests}
                    onCheckAftersHours={onCheckAftersHours}
                    formRef={formRef}
                    setError={setError}
                    setIsValidForm={setIsValidForm}
                    isEstimate={isEstimate}
                    successfulSubmit={successfulSubmit}
                    setSuccessfulSubmit={setSuccessfulSubmit}
                    resetTouch={resetTouch}
                    setResetTouch={setResetTouch}
                    images={images}
                    photosIds={photosIds}
                    setImages={setImages}
                    setPhotosIds={setPhotosIds}
                />
            </div>
            <RenderFooter
                steps={steps}
                error={error}
                isValidForm={isValidForm}
                allowSubmitWithError={allowSubmitWithError}
                handleNextStep={onNextStep}
                history={history}
            />
        </ContentLayout>
    )
}

RequestPageComponent.propTypes = {
    isEstimate: PropTypes.bool.isRequired,
    steps: PropTypes.array.isRequired,
    setSteps: PropTypes.func.isRequired,
    afterHoursModalOpen: PropTypes.bool.isRequired,
    setAfterHoursModalOpen: PropTypes.func.isRequired,
    onCreateRequest: PropTypes.func.isRequired,
    selectedAsset: PropTypes.array.isRequired,
    setSelectedAsset: PropTypes.func.isRequired,
    filteredOpenRequests: PropTypes.array.isRequired,
    onFilterOpenRequests: PropTypes.func.isRequired,
    onCheckAftersHours: PropTypes.func.isRequired,
    formRef: PropTypes.object,
    error: PropTypes.string,
    setError: PropTypes.func.isRequired,
    isValidForm: PropTypes.bool.isRequired,
    allowSubmitWithError: PropTypes.bool,
    setIsValidForm: PropTypes.func.isRequired,
    successfulSubmit: PropTypes.bool.isRequired,
    setSuccessfulSubmit: PropTypes.func.isRequired,
    resetTouch: PropTypes.bool.isRequired,
    setResetTouch: PropTypes.func.isRequired,
    images: PropTypes.array.isRequired,
    photosIds: PropTypes.array.isRequired,
    setImages: PropTypes.func.isRequired,
    setPhotosIds: PropTypes.func.isRequired,
    onNextStep: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    listOfRequests: PropTypes.array.isRequired,
}

export default RequestPageComponent
